import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Row, Col, Container, Button, Image } from "react-bootstrap";
import axios from "axios";
import Header from "../global/Header";
import Footer from "../global/Footer";
import ideaImg from "../../assets/idea.png";
import classes from "./DetailsPage.module.css";
import "../../assets/css/style.css";
import business1Img from "../../assets/Business1.png";
import business3Img from "../../assets/Business3.png";
import business4Img from "../../assets/Business4.png";
import business7Img from "../../assets/Business7.png";
import pm2Img from "../../assets/pm2.png";
import pm4Img from "../../assets/pm4.png";
import { baseUrl } from "../../consts/consts";
import Loader from "../global/Loader";
import SomethingWentWrongComponent from "../global/SomethingWentWrongComponent";
import ComingSoonComponent from "../global/ComingSoonComponent";

const DetailsPage = () => {
  const [product, setProduct] = useState(null);
  const [loader, setLoader] = useState(true);
  const [error, setError] = useState(false);
  const [notFound, setNotFound] = useState(false);
  const { product: productSlug } = useParams();

  useEffect(() => {
    getProduct(productSlug);
  }, [productSlug]);
  const getProduct = async (productSlug) => {
    try {
      setLoader(true);
      const { data } = await axios.get(`${baseUrl}/products/${productSlug}`);

      if (data.data) {
        setProduct(data.data.product);
      } else {
        setNotFound(true);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      if (error && error.response && error.response.status === 404) {
        setNotFound(true);
      } else {
        setError(true);
      }
    }
  };
  return (
    <>
      <Header />
      <section className="bodys1">
        {loader && <Loader />}
        {!loader && (
          <div className={error || notFound ? "" : classes.greenOverlay}>
            <>
              {error && <SomethingWentWrongComponent />}
              {notFound && !error && <ComingSoonComponent />}
              {!notFound && !error && product && (
                <Container>
                  <Row>
                    <Col md={7}>
                      <div
                        className={"mt-4 " + classes.courseContent}
                        dangerouslySetInnerHTML={{
                          __html: product.description,
                        }}
                      />
                    </Col>
                    <Col md={5}>
                      <div className={classes.priceContainer}>
                        <Image
                          src={ideaImg}
                          alt="idea image"
                          className={classes.ideaImage}
                        />
                        <div className={classes.price}>
                          <h5>
                            <Image src={business4Img} /> Re-Skilling Deploma{" "}
                          </h5>
                          <h5>
                            <Image src={business3Img} />
                            Duration - 4 Weeks
                          </h5>
                          <h5>
                            <Image src={business1Img} />
                            Self Paced
                          </h5>
                          <h5>
                            <Image src={pm4Img} />
                            Direct Access To Linkedin Jobs
                          </h5>
                          <h5>
                            <Image src={business7Img} />
                            Membership of BCS/ILM**
                          </h5>
                          <h5>
                            <Image src={pm2Img} />
                            Fee - ${product.sale_price}
                          </h5>
                          <div className="text-center">
                            <Link to={product.sign_up_link} target={'_blank'}>
                              <Button>Sign Up</Button>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>
              )}
            </>
          </div>
        )}
        <Footer />
      </section>
    </>
  );
};

export default DetailsPage;
